import React from 'react';

import QueryString from 'query-string';
import Tweezer from 'tweezer.js';

import SearchService from 'services/SearchService';

import SearchField from './SearchField';
import SearchResults from './SearchResults';
import SearchPager from './SearchPager';

class Search extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searched: false,
            query: '',
            offset: 0,
            amount: 0,
            total: 0,
            items: [],
        };
    }

    componentDidMount = () => {
        window.addEventListener('popstate', this.fetchStateFromUrlAndSearch);
        this.fetchStateFromUrlAndSearch();
    };

    fetchStateFromUrlAndSearch = async () => {
        const {
            query,
            offset,
            amount,
        } = QueryString.parse(window.location.search);

        const response = await SearchService.search(query, offset, amount);
        this.setState({
            searched: !!query,
            query: query || '',
            offset: offset || 0,
            amount: amount || 10,
            total: response.total || 0,
            items: response.results || [],
        });
    };

    scrollToTop = () => {
        const twzr = new Tweezer({
            start: window.scrollY,
            end: (this.container.getBoundingClientRect().top + 20) + window.scrollY,
            duration: 200,
        });

        twzr.on('tick', (value) => {
            window.scrollTo(0, value);
        });

        twzr.begin();
    };

    handleUpdateQuery = (query) => {
        this.setState({
            query,
            offset: 0,
        });
    };

    handleUpdateOffset = (offset) => {
        this.setState({
            offset,
        }, this.handleSearch);

        this.scrollToTop();
    };

    handleSearch = async () => {
        const {
            query,
            offset,
            amount,
        } = this.state;

        const base = window.location.toString().split('?')[0];
        const search = QueryString.stringify({
            query,
            offset,
            amount,
        });

        history.pushState({}, '', `${base}?${search}`); // eslint-disable-line no-restricted-globals
        this.fetchStateFromUrlAndSearch();
    };

    render = () => {
        const {
            searched,
            query,
            total,
            items,
            offset,
            amount,
        } = this.state;

        return (
            <div
                className="search-results"
                ref={(container) => { this.container = container; }}
            >
                <SearchField
                    query={query}
                    handleUpdateQuery={this.handleUpdateQuery}
                    handleSearch={this.handleSearch}
                />
                <SearchResults
                    searched={searched}
                    items={items}
                    total={total}
                />
                <SearchPager
                    total={total}
                    offset={offset}
                    amount={amount}
                    handleUpdateOffset={this.handleUpdateOffset}
                />
            </div>
        );
    };
}

export default Search;
